export const formatFileSize = sizeInBytes => {
  const units = ["B", "kB", "MB", "GB", "TB"];
  const index = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
  const fileSize = (sizeInBytes / Math.pow(1024, index)).toFixed(2);

  return `${fileSize} ${units[index]}`;
};
